import React, { useContext } from 'react';
import { string } from 'prop-types';
import {
  number as numberType,
  params,
  shape as shapeType,
  string as stringType
} from '@thd-nucleus/data-sources';
import { useProductDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';
import { ExperienceContext, useStoreId } from '@thd-nucleus/experience-context';
import { useLayoutGroupProps } from '@thd-olt-component-react/layout-manager';
import { LoadingPlaceholder } from '@thd-olt-component-react/loading-placeholder';
import { IntroOffer } from './IntroOffer.component';
import { PaymentEstimator } from './paymentEstimator/PaymentEstimator.component';

export const ConsumerCardMessaging = (props) => {
  const experienceContext = useContext(ExperienceContext);
  const { channel } = experienceContext;
  const { itemId } = props;
  const { paymentEstimatorVersion = 'v1.0.25' } = useLayoutGroupProps({ props });
  const storeId = useStoreId();
  const { data, error, loading } = useProductDeprecated({ itemId, storeId, domains: ['pricing', 'identifiers'] });
  // const { data, error, loading } = useDataModel('product', { variables: { itemId } });

  if (error && !data && !loading) {
    return null;
  }

  if (loading) {
    return (
      <LoadingPlaceholder
        type="text"
        ready={false}
        color="#E0E0E0"
        rows={2}
        showLoadingAnimation
      >
        Loading...
      </LoadingPlaceholder>
    );
  }

  const pricing = data?.product?.pricing;
  const isAppliance = data?.product?.identifiers?.productType === 'MAJOR_APPLIANCE';
  if (!pricing) return null;

  const { value } = pricing;
  return value >= 299.00
    ? (
      <PaymentEstimator
        price={`${value}`}
        mobile={channel === 'mobile'}
        fileVersion={paymentEstimatorVersion}
        isAppliance={isAppliance}
      />
    )
    : <IntroOffer mobile={channel === 'mobile'} fileVersion={paymentEstimatorVersion} />;
};

ConsumerCardMessaging.displayName = 'ConsumerCardMessaging';

ConsumerCardMessaging.dataModel = {
  product: params({
    itemId: stringType().isRequired()
  }).shape({
    pricing: params({ storeId: stringType() }).shape({
      value: numberType()
    }),
    identifiers: shapeType({
      productType: stringType()
    })
  })
};

ConsumerCardMessaging.propTypes = {
  itemId: string.isRequired
};
